import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`

let api = {
  // 活动分页
  getEventPage: `${baseUrl}/event/getPage`,

  // 添加活动
  addEvent: `${baseUrl}/event/add`,

  // 修改活动
  updateEvent: `${baseUrl}/event/update`,

  // 查询活动详情
  getEventByCode: `${baseUrl}/event/getByCode`,

  // 删除活动
  deleteEventByCodes: `${baseUrl}/event/deleteByCodes`,

  // 收款账户列表
  getAccountList: `${baseUrl}/event/getAccountList`,

  // 门禁设备列表
  getAccessDeviceList: `${baseUrl}/event/getAccessDeviceList`,

  // 报名记录分页
  getRegistrationRecordPage: `${baseUrl}/registrationRecord/getPage`,

  // 缴费记录分页
  getConsumptionRecordPage: `${baseUrl}/consumptionRecord/getPage`,

  // 报名统计分页
  getEventStatisticsPage: `${baseUrl}/eventStatistics/getPage`,

  // 上传图片
  uploadImg: `${baseUrl85}/yqNews/uploadImg`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/activity.js